import styled from '@emotion/styled';

export const Chart = styled.div`
  font-size: 13px;
  width: 1000px;
  height: 500px;
`

export const SearchForm = styled.div`
  display: grid;
  grid-template-columns: 200px 200px 100px;
  column-gap: 20px;
`

export const ButtonContainer = styled.div`
  padding-top: 20px;
`

export const Tip = styled.div`
  font-size: 14px;
`
